import React from "react";
import "./BreakView.scss";

export const BreakView: React.FC = () => (
  <div className="c-break-view">
    <span>...</span>
  </div>
);
